var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLandingLine1690 = function SvgLandingLine1690(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 436,
    height: 1699,
    fill: "none",
    className: "landing-line-1690_svg__landing-line-1690"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 3,
    d: "M375 .5v32.02c0 52.068-31.693 99.194-79.75 119.23s-79.75 67.162-79.75 119.229v123.808c0 58.726 39.665 110.04 96.496 124.838l24.008 6.25c56.831 14.798 96.496 66.112 96.496 124.838v73.053c0 68.343-53.301 124.826-121.53 128.783l-187.94 10.902C54.802 867.408 1.5 923.891 1.5 992.234v55.956c0 70.78 57.032 128.34 127.808 128.99l177.384 1.64c70.776.65 127.808 58.21 127.808 128.99v53.91c0 71.67-45.486 135.44-113.25 158.78S208 1607.61 208 1679.28v19.22"
  })));
};
export default SvgLandingLine1690;